/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ArrowRight, ArrowLeft, CalendarBlank, Plus, SignOut } from "@phosphor-icons/react";
import eventLogo from "../../assets/images/eventlogo.svg";
import disabledEvent from "../../assets/images/disabledStoreFront.svg";
import noQLogo from "../../assets/icons/NO-QLogo-new.svg";
import Loader from "../../common/Loader";
import { eventActions } from "../../redux/actions";
import CreateEvent from "../../common/CreateEvent";
import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic-light-dark.css";

const Dashboard = () => {
    const [addEvent, setAddEvent] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [events, setEvents] = useState([]);
    const [page, setPage] = useState(1);
    const [eventPagination, setEventPagination] = useState({ current: 1, number_of_pages: 1 });
    const noqEventUser = localStorage.getItem("noqEventUser") || sessionStorage.getItem("noqEventUser");
    const userObj = JSON.parse(noqEventUser || "{}");
    const token = userObj?.token;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isFetchingEvents, isFetchedEventsSuccess, isFetchingOrganizers, isFetchedOrganizersSuccess } = useSelector((state) => state.eventManager);

    const logout = () => {
        localStorage.removeItem("noqEventUser");
        sessionStorage.removeItem("noqEventUser");
        window.dispatchEvent(new Event("storage"));
    };

    useEffect(() => { if (token) dispatch(eventActions.getOrganizers(token)); }, [dispatch, token]);

    useEffect(() => {
        if (isFetchedOrganizersSuccess && token) {
            sessionStorage.setItem("organizerInfo", JSON.stringify(isFetchedOrganizersSuccess?.[0]));
            dispatch(eventActions.getEvents(isFetchedOrganizersSuccess?.[0]?.id, token, page));
        }
    }, [dispatch, isFetchedOrganizersSuccess, token, page]);

    useEffect(() => {
        if (isFetchedEventsSuccess) {
            setIsLoading(false);
            setEvents(isFetchedEventsSuccess?.data || []);
            setEventPagination({ current: isFetchedEventsSuccess?.meta?.current_page || 1, number_of_pages: isFetchedEventsSuccess?.meta?.last_page || 1 });
        }
    }, [isFetchedEventsSuccess]);

    const goToPage = (next) => {
        setPage(next);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    if (addEvent) return <CreateEvent setAddStore={setAddEvent} />;

    return (
        <div className="noq-events-page">
            <aside className="noq-sidebar noq-events-sidebar" aria-label="Organizer navigation">
                <div>
                    <div className="noq-sidebar__brand">
                        <img src={noQLogo} alt="NO-Q" />
                        <div><span>ORGANIZER</span><strong>Event control</strong></div>
                    </div>
                    <nav className="noq-sidebar__nav">
                        <p className="noq-sidebar__label">WORKSPACE</p>
                        <button className="noq-sidebar__link is-active" type="button">
                            <CalendarBlank size={19} weight="fill" /><span>My events</span>
                        </button>
                    </nav>
                </div>
                <button className="noq-sidebar__logout" onClick={logout}><SignOut size={19} />Log out</button>
            </aside>

            <section className="noq-events-content">
                <div className="noq-events-mobile-brand"><img src={noQLogo} alt="NO-Q" /><button onClick={logout}><SignOut size={20} /><span>Log out</span></button></div>
                <header className="noq-page-header">
                    <div>
                        <p className="noq-page-eyebrow">EVENT OPERATIONS</p>
                        <h1 className="noq-page-title">My events</h1>
                        <p className="noq-page-subtitle">Select an event to manage vendors, revenue, and performance.</p>
                    </div>
                    <button className="noq-primary-action" onClick={() => setAddEvent(true)}><Plus size={19} weight="bold" />Create event</button>
                </header>

                {(isLoading || isFetchingOrganizers || isFetchingEvents) ? (
                    <div className="noq-dashboard-loader"><Loader color="#CEF24E" /><span>Loading events</span></div>
                ) : (
                    <div id="scrollContainer" className="noq-event-list">
                        {events.map((event) => {
                            const isActive = event?.status?.toLowerCase() === "published";
                            return (
                                <article key={event?.id} className={`noq-event-row ${isActive ? "is-active" : ""}`} onClick={() => navigate(`/dashboard/event/${event.id}`)} onKeyDown={(e) => e.key === "Enter" && navigate(`/dashboard/event/${event.id}`)} role="link" tabIndex="0">
                                    <img className="noq-event-row__image" src={isActive ? (event?.logo_url || eventLogo) : disabledEvent} alt="" />
                                    <div className="noq-event-row__body"><h2 className="noq-event-row__title">{event?.name}</h2><span className={`noq-status ${isActive ? "is-active" : ""}`}>{isActive ? "Active" : "Inactive"}</span></div>
                                    <span className="noq-event-row__arrow" aria-hidden="true"><ArrowRight size={18} /></span>
                                </article>
                            );
                        })}

                        {!events.length && <div className="noq-empty-state"><CalendarBlank size={46} weight="duotone" /><h2>No events yet</h2><p>Create your first event to start inviting vendors.</p></div>}

                        {eventPagination.number_of_pages > 1 && <div className="noq-pagination"><ResponsivePagination current={page} total={eventPagination.number_of_pages} maxWidth={360} previousLabel={<ArrowLeft size={20} />} nextLabel={<ArrowRight size={20} />} onPageChange={goToPage} /></div>}
                    </div>
                )}
            </section>
        </div>
    );
};

export default Dashboard;
